import { SettingsTemplate } from "@/components/Templates";
import type { SettingsTabId } from "@/components/Templates/Settings/Settings.template.types";
import { useSettingsPage } from "@/hooks/useSettingsPage";

type SettingsPageProps = {
  initialTab?: SettingsTabId;
};

export function SettingsPage({ initialTab }: SettingsPageProps) {
  const settings = useSettingsPage(initialTab);

  return <SettingsTemplate {...settings} />;
}
